import * as React from "react";

export const ArrowDownIcon = (props: any) => (
  <svg
    width={12}
    height={8}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1 1.5 5 5 5-5"
      stroke="#A3A3A6"
      strokeWidth={1.667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
